import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/backend';
import { WebSilobagsData, WebSilobagsPayload } from './silobag-web.types';

export async function listWebSilobagsService(organizationId: WebSilobagsPayload) {
  const { response, data } = await BACKEND.get<WebSilobagsData>(ENDPOINT.WEB_SILOBAGS, {
    params: '/' + organizationId,
  });

  return {
    response,
    summary: data,
  };
}
